
const titleObj = {
    "VERIFY_KYC": "KYC Verification",
    "VISIT": "Visit",
    "REFUND_DEALER_ADMIN": "Wallet Refund",
    "POLICY_CANCEL": "Policy Cancellation",
    "POLICY_CANCEL_DIRECT": "Policy Cancellation",
    "POLICY_EDIT": "Policy Edit",
    "POLICY_EDIT_DIRECT": "Policy Edit",
    "ONLINE": "Payment Gateway",
    "OFFLINE": "EA Wallet",
    "VA_NAVISION_DEALER": "ECollection",
    "VA-NAVISION-DEALER": "ECollection",
    "VA-NAVISION-ADMIN": "ECollection",
    "VA_NAVISION_ADMIN": "ECollection map",
    "POLICY_REFUND": "Policy refund",
    "POLICY_REFUND2": "Wallet refund rejected",
    "WALLET_REFUND": "Wallet refund",
    "REFUND_AUTO": "Wallet refund transaction",
    "WALLET_REFUND_AUTO": "Wallet refund transaction",
    "SELF_ONLINE": "Payment Gateway",
    "CLOSOURE_INITIATED": "Closure Initiated",
    "USER_EDIT": "User Edit",
    // "WALLET_CLOSURE": "Wallet Closure",
    "REFUND_REQUEST": "Refund Request",
    "DEALER_WALLET_CLOSURE": "Wallet Closure",

}
const getTitle = (key) => {
   return titleObj[key] ? titleObj[key] : key;
}

export default getTitle;